/**
 * Utility functions for formatting data in the application
 */

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || amount === "Could not find data") {
    return "Could not find data";
  }
  
  // Handle range objects
  if (typeof amount === 'object' && amount !== null) {
    if (amount.isRange) {
      const minFormatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount.min);
      
      const maxFormatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount.max);
      
      return `${minFormatted} - ${maxFormatted}`;
    } else {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount.min);
    }
  }
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatPercentage = (value) => {
  if (value === null || value === undefined || value === "Could not find data") {
    return "Could not find data";
  }
  
  // Handle range objects
  if (typeof value === 'object' && value !== null) {
    if (value.isRange) {
      return `${value.min.toFixed(1)}% - ${value.max.toFixed(1)}%`;
    } else {
      return `${value.min.toFixed(1)}%`;
    }
  }
  
  return `${typeof value === 'number' ? value.toFixed(1) : value}%`;
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === "Could not find data") {
    return "Could not find data";
  }
  
  // Handle range objects
  if (typeof value === 'object' && value !== null) {
    if (value.isRange) {
      return `${value.min.toLocaleString()} - ${value.max.toLocaleString()}`;
    } else {
      return value.min.toLocaleString();
    }
  }
  
  return typeof value === 'number' ? value.toLocaleString() : value;
};

export const formatConfidence = (score) => {
  if (score === null || score === undefined || score === "Could not find data") {
    return "Could not find data";
  }
  
  return typeof score === 'number' ? `${(score * 100).toFixed(1)}%` : score;
}; 